import { CustomData, useData } from '@kameleoon/react-sdk';
import { useCallback } from 'react';
import { useKameleoonState } from './useKameleoonState';

export type CustomDataName = 'RequestSource' | 'Module' | 'Section';

/**
 * Should be manually synced with Kameleoon dashboard Custom Data settings
 * https://app.kameleoon.com/customData/dashboard
 */
const CustomDataIndexMap: Record<CustomDataName, number> = {
    RequestSource: 5,
    Module: 2,
    Section: 1,
};

type CustomDataRecord = {
    name: CustomDataName;
    value: string;
};

export const useAddCustomData = () => {
    const { state } = useKameleoonState();
    const { addData } = useData();

    const addCustomData = useCallback(
        (record: CustomDataRecord) => {
            if (state.status !== 'initialized' || !state.visitorCode) {
                return;
            }
            const data = new CustomData(CustomDataIndexMap[record.name], record.value);
            addData(state.visitorCode, data);
        },
        [addData, state],
    );

    return addCustomData;
};
